export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.7-1024.01",
  commitId: "e560500c95337cdf782bc4d5d8c214f76118209d",
  commitTime: "2026-09-07T10:24:01.000Z",
});
